import { Modal } from "@msys/ui";
import { TextField } from "@mui/material";
import React from "react";

interface Props {
  handleClose: () => void;
  handleComplete: (content: string, handleClose: () => void) => void;
}

export const GetUrlContentModal = ({ handleClose, handleComplete }: Props) => {
  const [url, setUrl] = React.useState("");

  const handleLoad = async () => {
    const content = await fetch(url).then(res => res.text());
    handleComplete(content, handleClose);
  };

  return (
    <Modal
      handleClose={handleClose}
      actionButtons={[
        {
          label: "Cancel",
          handleClick: handleClose,
          buttonProps: { variant: "text" },
        },
        {
          label: "Load",
          handleClick: handleLoad,
          buttonProps: {
            variant: "contained",
            disabled: !url,
          },
        },
      ]}
    >
      <TextField
        label="URL"
        fullWidth
        value={url}
        onChange={e => {
          setUrl(e.target.value);
        }}
      />
    </Modal>
  );
};
